import React from 'react';
import { motion } from 'framer-motion';

const TechyAnimation = () => {
  const gridSize = 15;
  const dots = Array.from({ length: gridSize * gridSize });

  const dotVariants = {
    initial: {
      opacity: 0.1,
      scale: 0.5,
    },
    animate: (i) => ({
      opacity: [0.1, 1, 0.1],
      scale: [0.5, 1, 0.5],
      transition: {
        duration: 2,
        repeat: Infinity,
        repeatType: 'loop',
        delay: (i % gridSize) * 0.1 + Math.floor(i / gridSize) * 0.1,
      },
    }),
  };

  return (
    <div className="relative flex justify-center items-center w-full h-full">
        <div 
            className="grid gap-4"
            style={{ gridTemplateColumns: `repeat(${gridSize}, 1fr)` }}
        >
            {dots.map((_, i) => (
                <motion.div
                    key={i}
                    className="w-2.5 h-2.5 bg-sky-300 rounded-full"
                    variants={dotVariants}
                    initial="initial"
                    animate="animate"
                    custom={i}
                />
            ))}
      </div>
       <div className="absolute inset-0 bg-gradient-to-t from-gray-50/50 to-transparent"></div>
    </div>
  );
};

export default TechyAnimation; 